var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('BreadScrumbs',{attrs:{"links":[
      {
        name: 'Investor Relations',
        to: {
          name: 'IR'
        },
      },
       {
        name: 'Detail Page',
        to: {
          name: 'IRFinacialInformationDetailPage'
        },
      }
    ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("Detail Page")]),_c('v-spacer'),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.createHandler}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"white"}},[_vm._v("add")]),_c('span',[_vm._v("新增")])],1)],1),_c('DetailPageTable',{staticClass:"mb-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }